module.exports = __webpack_public_path__ + "img/profile-bg6.57e9db61.jpg";